import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
const CompetitionType = forwardRef(({ defaultvar = '' }, ref) => {
  const currencies_competition_type = [
    {
      value: 'Рейтинговое соревнование',
      label: 'Рейтинговое соревнование',
    },
    {
      value: 'Коммерческое соревнование',
      label: 'Коммерческое соревнование',
    },
  ]

  const [value, setValue] = React.useState(defaultvar)
  const [error, setError] = useState('')

  const val = () => {
    return value.trim()
  }
  const validate = () => {
    if (value.trim() === '') {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))

  return (
    <TextField
      id="competition_type"
      select
      label="Тип соревнования"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      variant="filled"
      error={!!error}
      // helperText={error}
    >
      {currencies_competition_type.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
})

export default CompetitionType
